import { routesByUserType, authRoutes, publicRoutes } from './index';
import { isProRoute } from './proRoutes';

const applyProvider = (routes, provider) =>
  provider ? routes.map((r) => ({ ...r, element: provider(r.element) })) : routes;

// plan: 'lite' | 'pro'. Por defecto 'lite' (fail-safe): si no se conoce el
// plan del tenant se asume el mínimo y no se exponen rutas Pro accidentalmente.
// El SecureRouter siempre pasa `tenant?.plan ?? 'lite'` explícito, por lo que
// el default solo aplica a llamadas sin contexto de tenant (ej. tests unitarios
// que no evalúan gating; esos deben pasar 'pro' si necesitan el set completo).
export default function resolveRoutes(userType, plan = 'lite') {
  const config = routesByUserType[userType];
  if (!config) return [...publicRoutes, ...authRoutes];
  const applied = applyProvider(config.routes, config.provider);
  const gated = plan === 'pro' ? applied : applied.filter((r) => !isProRoute(r.path));
  return [...gated, ...authRoutes];
}
